// media-overlay
// Das Overlay-Markup steht bewusst nicht im FTL: Magnolia rendert jede
// Komponente einzeln, ein <dialog> im Template waere pro Instanz einmal
// vorhanden. Hier entsteht genau einer pro Seite, der beim Klick aus dem
// jeweiligen Button befuellt wird. Geoeffnet wird er mit show(), nicht mit
// showModal(): nur ein modaler Dialog liegt im Top-Layer ueber dem Inhalt. So
// bleibt er ein gewoehnliches Element im Fluss und schiebt beim Oeffnen den
// uebrigen Inhalt von <main> nach unten (UA-Styles dazu in _prototype.scss).
runWhenDomReady(() => {
  const buttons = [...document.querySelectorAll('.media-button')];
  if (!buttons.length) return;

  const DIALOG_ID = 'media-overlay';
  const TITLE_ID = 'media-overlay-title';

  // Beschriftungen kommen aus dem Resource-Bundle und haengen als data-text-*
  // an jedem .media-button (siehe media-overlay.ftl) — der erste genuegt.
  // prev/next beschriften spaeter die Slider-Pfeile.
  const labels = {
    close: buttons[0].dataset.textClose || '',
    prev: buttons[0].dataset.textPrev || '',
    next: buttons[0].dataset.textNext || ''
  };

  // Aufbau des Dialogs. Es gibt kein CSS fuer das Overlay, die Reihenfolge
  // im DOM ist damit zugleich die Lesereihenfolge.
  const dialog = document.createElement('dialog');
  dialog.id = DIALOG_ID;
  dialog.className = 'media-overlay';

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'media-overlay-close';
  closeButton.textContent = labels.close;

  const title = document.createElement('h2');
  title.id = TITLE_ID;
  title.hidden = true;

  // Bewusst kein <p>: der Text kommt aus dem Richtext-Feld und bringt eigene
  // <p> mit. Absaetze ineinander waeren ungueltiges Markup.
  const text = document.createElement('div');
  text.className = 'media-overlay-text';
  text.hidden = true;

  // Bleibt leer: das Splide-Geruest entsteht bei jedem Oeffnen neu und wird
  // beim Schliessen wieder entfernt.
  const sliderHost = document.createElement('div');
  sliderHost.className = 'media-overlay-slider';
  sliderHost.hidden = true;

  dialog.append(closeButton, title, text, sliderHost);

  // Erstes Kind von <main> (aus prototype.ftl des master6-module, auf jeder
  // Seite vorhanden), damit der Dialog im selben Vererbungszweig wie der
  // Seiteninhalt haengt — Schrift, Zeilenhoehe und die davon abhaengigen
  // lh-Masse des Overlay-CSS stimmen dadurch mit der Seite ueberein.
  document.querySelector('main').prepend(dialog);

  // Merkt sich den ausloesenden Button, um den Fokus spaeter zurueckzugeben.
  let activeButton = null;

  // Titel, Text und Bilder liegen als fertiges Markup im <template> des
  // Buttons (siehe media-overlay.ftl). Der Inhalt eines <template> ist ein
  // DocumentFragment: nicht dargestellt, nichts wird geladen, und Klonen
  // verbraucht ihn nicht.
  const payloadOf = button => button.querySelector('template.media-payload')?.content;

  // Jedes Feld wird bei jedem Oeffnen neu gesetzt — auch das leere. Vom
  // vorherigen Button bleibt damit nichts stehen, ein eigener Ruecksetzschritt
  // eruebrigt sich.
  function fillOverlay(button) {
    const payload = payloadOf(button);
    const titleSource = payload?.querySelector('[data-media-title]');
    const textSource = payload?.querySelector('[data-media-text]');

    const headline = titleSource?.textContent.trim() || '';
    title.textContent = headline;
    title.hidden = !headline;

    // Geklont statt als Zeichenkette gesetzt: im <template> steht bereits
    // geparstes Markup, damit bleibt die Auszeichnung aus dem Richtext-Feld
    // erhalten, ohne sie ein zweites Mal durch eine Escaping-Kette zu schicken.
    const body = textSource ? [...textSource.cloneNode(true).childNodes] : [];
    text.replaceChildren(...body);
    text.hidden = !body.length;

    // Ein Dialog braucht einen zugaenglichen Namen. Gibt es einen Titel, zeigt
    // aria-labelledby auf die <h2>, sonst uebernimmt das aria-label des
    // Buttons. Immer nur eines von beiden — zusammen wuerde aria-labelledby
    // das aria-label ueberstimmen und die Absicht verwischen.
    if (headline) {
      dialog.setAttribute('aria-labelledby', TITLE_ID);
      dialog.removeAttribute('aria-label');
    } else {
      dialog.removeAttribute('aria-labelledby');
      const fallback = button.getAttribute('aria-label') || '';
      if (fallback) {
        dialog.setAttribute('aria-label', fallback);
      } else {
        dialog.removeAttribute('aria-label');
      }
    }
  }

  // Splide-Instanz des Overlays, nur zwischen Oeffnen und Schliessen gesetzt.
  let splide = null;

  // Live-Abfrage: die Einstellung kann sich waehrend der Sitzung aendern, die
  // Liste wird bei jedem Zugriff neu ausgewertet.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Baut das Splide-Geruest aus den Bildern der Nutzlast auf und gibt die
  // Wurzel zurueck — oder null, wenn es keine Bilder gibt. Bewusst bei jedem
  // Oeffnen neu: Splide legt beim Mounten eigene Knoten und Attribute an
  // (Pfeile, Rollen an den Slides). Ein frischer Baum ist verlaesslicher, als
  // sich darauf zu verlassen, dass destroy() jede Spur zurueckbaut.
  function buildSlider(button) {
    const payload = payloadOf(button);
    const images = payload ? [...payload.querySelectorAll('img')] : [];

    sliderHost.replaceChildren();
    sliderHost.hidden = !images.length;
    if (!images.length) return null;

    const root = document.createElement('div');
    // media-overlay-splide haelt init-slider.js von diesem Slider fern.
    root.className = 'splide media-overlay-splide';
    const track = document.createElement('div');
    track.className = 'splide__track';
    const list = document.createElement('ul');
    list.className = 'splide__list';

    images.forEach(image => {
      const slide = document.createElement('li');
      slide.className = 'splide__slide';
      // Der Klon bringt srcset, den src-Fallback und alt mit, so wie
      // renderMedia sie gerendert hat.
      slide.append(image.cloneNode(true));
      list.append(slide);
    });

    track.append(list);
    root.append(track);
    sliderHost.append(root);
    return root;
  }

  function mountSlider(root) {
    splide = new Splide(root, {
      // Kein Loop: am ersten und letzten Bild ist Schluss, Splide deaktiviert
      // die Pfeile dort von selbst.
      type: 'slide',
      // focus 'center' allein genuegt nicht — ohne trimSpace liesse Splide das
      // erste und letzte Bild am Rand kleben, statt sie zu zentrieren.
      focus: 'center',
      trimSpace: false,
      pagination: false,
      // Splide beschriftet die Pfeile sonst englisch.
      i18n: {
        prev: labels.prev,
        next: labels.next
      }
    });
    splide.mount();
  }

  function destroySlider() {
    if (splide) {
      splide.destroy(true);
      splide = null;
    }
    sliderHost.replaceChildren();
    sliderHost.hidden = true;
  }

  function openOverlay(button) {
    // Derselbe Button aendert nichts — ein Neuaufbau wuerde den Slider bloss
    // auf das erste Bild zuruecksetzen.
    if (dialog.open && button === activeButton) return;

    // Seit der Dialog nicht mehr modal ist, bleibt die Seite bedienbar: ein
    // zweiter Button laesst sich bei offenem Overlay anklicken. Dann uebernimmt
    // dessen Inhalt das Overlay.
    //
    // Bewusst ohne close(): das close-Event feuert erst als eigene Aufgabe,
    // also nach dem Neuaufbau — der close-Listener raeumte damit den frisch
    // gemounteten Slider gleich wieder ab. destroySlider() erledigt hier
    // dasselbe, nur sofort. Der Rest des Inhalts wird ohnehin ueberschrieben.
    if (dialog.open) destroySlider();

    activeButton = button;
    fillOverlay(button);
    const root = buildSlider(button);

    // Ohne open-Attribut blendet der Browser den Dialog von sich aus aus
    // (dialog:not([open]) { display: none }), ein eigenes hidden eruebrigt sich.
    // show() setzt ausserdem den Fokus in den Dialog, hier auf den Schliessen-
    // Knopf als erstes fokussierbares Element. Beim Wechsel bei offenem Dialog
    // entfaellt das: der Fokus bleibt auf dem angeklickten Button.
    if (!dialog.open) dialog.show();

    // Erst jetzt mounten: Splide misst beim Mounten die Breite, im noch
    // unsichtbaren Dialog waere sie 0.
    if (root) mountSlider(root);

    // Das Overlay sitzt am Anfang von <main>, der angeklickte Button oft weiter
    // unten — ohne Sprung waechst der Inhalt ausserhalb des Sichtbereichs.
    // Den Abstand zum klebenden Seitenkopf haelt scroll-margin-block-start aus
    // _minimals.scss frei, das gilt dort fuer alle Elemente.
    dialog.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  buttons.forEach(button => {
    // aria-controls war im Markup leer; es zeigt jetzt auf einen existierenden
    // Knoten, noch bevor der Dialog das erste Mal geoeffnet wird.
    button.setAttribute('aria-controls', DIALOG_ID);

    button.addEventListener('click', event => {
      // Im Author liegt der Magnolia-Editierbalken innerhalb des Buttons.
      // Ohne diese Weiche waere die Komponente dort nicht mehr bearbeitbar.
      if (event.target.closest?.('.mgnlEditorBar')) return;

      openOverlay(button);
    });
  });

  closeButton.addEventListener('click', () => dialog.close());

  // Escape schliesst von sich aus nur modale Dialoge. Der Listener haengt am
  // Dokument und nicht am Dialog: der Fokus kann bei einem nicht-modalen Dialog
  // auch ausserhalb liegen, dort soll Escape ebenso wirken.
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && dialog.open) dialog.close();
  });

  // Deckt Schliess-Knopf und Escape gleichermassen ab.
  dialog.addEventListener('close', () => {
    destroySlider();

    if (activeButton?.isConnected) activeButton.focus();
    activeButton = null;
  });
});
